angular.module("vgresiduos").factory("clientVersionService", [
	"$rootScope",
	"$interval",
	"$timeout",
	function ($rootScope, $interval, $timeout) {
		"use strict";

		const checkIntervalMs = 5 * 60 * 1000;
		const minCheckIntervalMs = 60 * 1000;
		const reloadAttemptKey = "vgr-client-version-reload-attempt";

		const current = Vgr.constants.clientVersion;
		let lastCheck = 0;
		let pendingBuild = null;
		let forcingReload = false;

		function isEnabled() {
			// build local (sem gulp) não tem versão gerada
			return current.build !== "local";
		}

		function start() {
			if (!isEnabled()) {
				return;
			}

			$interval(check, checkIntervalMs);
			document.addEventListener("visibilitychange", function () {
				if (document.visibilityState === "visible") {
					check();
				}
			});
			check();
		}

		function check() {
			const now = Date.now();
			if (forcingReload || now - lastCheck < minCheckIntervalMs) {
				return;
			}
			lastCheck = now;

			fetch("/version.json?t=" + now, { cache: "no-store" })
				.then(function (response) {
					return response.ok ? response.json() : null;
				})
				.then(function (published) {
					if (published) {
						$rootScope.$applyAsync(function () {
							onPublishedVersion(published);
						});
					}
				})
				.catch(function () {
					// sem rede ou deploy em andamento: tenta na próxima verificação
				});
		}

		function onPublishedVersion(published) {
			if (!published.build || published.build === current.build) {
				sessionStorage.removeItem(reloadAttemptKey);
				return;
			}

			// evita loop de reload se o servidor ainda entregar o bundle antigo
			if (sessionStorage.getItem(reloadAttemptKey) === published.build) {
				return;
			}

			if (published.contract > current.contract) {
				forceReload(published.build);
			} else {
				pendingBuild = published.build;
			}
		}

		function forceReload(publishedBuild) {
			forcingReload = true;
			sessionStorage.setItem(reloadAttemptKey, publishedBuild);

			if ($rootScope.labels) {
				$rootScope.$broadcast(Vgr.constants.evtShowInfoMessage, $rootScope.labels.PLEASE_UPDATE_INFORMATION_MESSAGE);
			}
			$timeout(function () {
				window.location.reload();
			}, 2500);
		}

		// troca de rota é o momento seguro para atualizar: não há formulário em edição
		function reloadOnNavigationIfPending(targetUrl) {
			if (!pendingBuild || forcingReload || !targetUrl) {
				return false;
			}

			sessionStorage.setItem(reloadAttemptKey, pendingBuild);
			window.location.assign(targetUrl);
			return true;
		}

		return {
			start: start,
			reloadOnNavigationIfPending: reloadOnNavigationIfPending
		};
	}
]);
